<template>
  <div
    :class="bem()"
  >
    <div :class="bem('container')">
      <aside>
        <div :class="bem('image-wrapper')">
          <div :class="[bem('product-image-shimmer'), 'vision-shimmer']" />
        </div>
      </aside>

      <div :class="bem('line-text')">
        <div
          :class="bem('heading')"
        >
          <div :class="[bem('heading-shimmer'), 'vision-shimmer']">
            &nbsp;
          </div>
          <div :class="[bem('price-shimmer'), 'vision-shimmer']">
            &nbsp;
          </div>
        </div>
        <div :class="bem('details')">
          <div :class="[bem('details-shimmer'), 'vision-shimmer']">
            &nbsp;
          </div>
          <div :class="[bem('qty-shimmer'), 'vision-shimmer']">
            &nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const bem = useBEM('CartItemShimmer')
</script>

<style lang="postcss">
.CartItemShimmer {
  @apply flex flex-col flex-wrap
    relative w-full;
}

.CartItemShimmer__container {
  @apply flex relative w-full leading-[20px];

  img {
    @apply w-full inline-block;
  }
}

.CartItemShimmer__image-wrapper {
  @apply w-[96px] relative mr-4;

  @screen md {
    width: 120px;
    @apply mr-6;
  }

  img {
    @apply w-full;
  }
}

.CartItemShimmer__product-image-shimmer {
  @apply w-full pb-[100%] rounded-lg;
}

.CartItemShimmer__line-text {
  @apply w-full md:py-2 flex flex-col justify-between;
}

.CartItemShimmer__heading {
  @apply flex flex-row justify-between gap-4;
}

.CartItemShimmer__details {
  @apply flex justify-between gap-4;
}

.CartItemShimmer__heading-shimmer {
  @apply max-w-[120px]
}

.CartItemShimmer__price-shimmer {
  @apply max-w-[56px] max-h-[16px]
}

.CartItemShimmer__details-shimmer {
  @apply max-w-[160px] min-h-[56px] opacity-40;
}

.CartItemShimmer__qty-shimmer {
  @apply max-w-[90px] min-h-[40px] opacity-40;
}
</style>
